import { render, staticRenderFns } from "./simplePie.vue?vue&type=template&id=2e8c912e&scoped=true&"
import script from "./simplePie.vue?vue&type=script&lang=js&"
export * from "./simplePie.vue?vue&type=script&lang=js&"
import style0 from "./simplePie.vue?vue&type=style&index=0&id=2e8c912e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c912e",
  null
  
)

export default component.exports